import $, { each } from "jquery";
import { modal } from "./modal.js";
//scroll量に応じて要素をトグル
export function contact() {
  //郵便番号が前半後半に分かれているので対応する
  const set_postalCode = () => {
    const postalCode__firstHalf = $("#js-postalCode__firstHalf").val();
    const postalCode__latterHalf = $("#js-postalCode__latterHalf").val();
    let postalCode;
    if (!postalCode__firstHalf && !postalCode__latterHalf) {
      postalCode = '';
    } else {
      postalCode = postalCode__firstHalf + "-" + postalCode__latterHalf;
    }
    $("#js-postalCode").val(postalCode);
  };
  $("#js-postalCode__firstHalf").change((e) => {
    set_postalCode();
  });
  $("#js-postalCode__latterHalf").change((e) => {
    set_postalCode();
  });

  //同意チェック※js-contact-agreeはinputタグに付与する。そうしないと1クリックで二度走ってしまう。よってparent()を使う
  $("#js-contact-agree").click((e) => {
    $(e.currentTarget).parent().toggleClass("is-active");
  });

  //確認用のモーダルを表示する
  const view_modal = () => {
    modal();
    const arr_formItem = [];
    $("#js-form")
      .find("input,textarea")
      .each((index, element) => {
        if ($(element).attr("type") == "radio") {
          if ($(element).prop("checked")) {
            arr_formItem.push($(element).val());
          }
        } else if ($(element).attr("name") == "_token") {
          //Laravelのcsrf_tokenの値を取得しないようにする
        } else if ($(element).hasClass("js-no-submitValue")) {
          //郵便番号が2つに分かれているのでモーダルに表示しないことを示すクラスを作成する。
        } else {
          arr_formItem.push($(element).val());
        }
      });

    for (let key in arr_formItem) {
      $("#js-contact__confirmation dd").eq(key).text(arr_formItem[key]);
    }
  };

  //バリデーションチェック※エラー時のクラスはformアイテムのwrapperにふる
  $("#js-contact-btn__confirmation").on("click", function (e) {
    //二度目以降のクリックに対応
    let flg_form_check = true;
    const init_formValidation = () => {
      $(".crf-form__item").each((index, element) => {
        $(element).removeClass("is-error");
        $(element).removeClass("is-error--required");
        $(element).removeClass("is-error--postalCode");
        $(element).removeClass("is-error--mail");
      });
    };
    init_formValidation();

    //未入力チェック
    $(".js-required").each(function () {
      //inputタグとtextareaタグのチェック
      if ($(this).find("input").val() == "") {
        flg_form_check = false;
        $(this).addClass("is-error");
        $(this).addClass("is-error--required");
      }
      if ($(this).find("textarea").val() == "") {
        flg_form_check = false;
        $(this).addClass("is-error");
        $(this).addClass("is-error--required");
      }
      //ラジオボタンが選択されているかチェック
      if ($(this).find('input[type="radio"]').attr("name")) {
        const radio_name = $(this).find('input[type="radio"]').attr("name");
        let num_radioChecked = 0;
        $(`input[name="${radio_name}"]`).each((index, element) => {
          if ($(element).prop("checked")) {
            num_radioChecked++;
          }
        });
        if (num_radioChecked == 0) {
          flg_form_check = false;
          $(this).addClass("is-error");
          $(this).addClass("is-error--required");
        }
      }
    });

    //郵便番号チェック
    if (
      $("#js-postalCode__firstHalf").val() != "" ||
      $("#js-postalCode__latterHalf").val() != ""
    ) {
      if (
        $("#js-postalCode")
          .val()
          .match(/\d{3}-\d{4}$/) == null
      ) {
        flg_form_check = false;
        $("#js-postalCode")
          .parents(".crf-form__item")
          .addClass("is-error--postalCode")
          .addClass("is-error");
      }
    }

    //メールアドレスの形式チェック
    if (
      !$("#js-contact__mail")
        .parents(".crf-form__item")
        .hasClass("is-error--required")
    ) {
      if (
        $("#js-contact__mail")
          .val()
          .match(
            /^[A-Za-z0-9][A-Za-z0-9_.-]*@[A-Za-z0-9_.-]+\.[A-Za-z0-9]+$/
          ) == null
      ) {
        flg_form_check = false;
        $("#js-contact__mail")
          .parents(".crf-form__item")
          .addClass("is-error--mail")
          .addClass("is-error");
      }
    }

    if (!flg_form_check) {
      const header_height = $(".l-header").height();
      const err_posi = $(".is-error").first().offset().top - header_height;
      $("html, body").animate({ scrollTop: err_posi }, 500, "swing");
    } else {
      //フォーム内容が正しい場合はモーダルを表示する。
      view_modal();
    }
  });
  $("#js-contact-btn__submit").on("click", function (e) {
    $("#js-form").submit();
  });
}
